import { Box } from '@chakra-ui/react'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import type { APIUser } from '../api'
import { HtmlContainer } from '../components'
import { tHtml } from '../i18n'
import { useUserAwareTranslation } from '../i18n/hooks'

interface StaticPageProps {
  user?: APIUser
  pageName?: string
  footerPage?: string
}
const StaticPage = (props: StaticPageProps) => {
  const { user, pageName = '', footerPage = '' } = props
  const { t } = useUserAwareTranslation(user)
  const [html, setHtml] = useState('')
  const [page, setPage] = useState('default.html')

  useEffect(() => {
    console.debug('[StaticPage] pageName', pageName)
    console.debug('[StaticPage] footerPage', footerPage)
    try {
      if (!_.isEmpty(footerPage)) {
        tHtml(footerPage, user).then((__html) => setHtml(__html))
      } else if (!_.isEmpty(page)) {
        tHtml(page, user).then((__html) => setHtml(__html))
      }
    } catch (error) {
      console.error('[StaticPage] footer error:', error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [html, page, footerPage])

  useEffect(() => {
    console.log('[StaticPage] pageName', pageName)
    console.log('[StaticPage] footerPage', footerPage)
    if (!_.isEmpty(pageName)) {
      const tmp = t(pageName)
      if (!_.isEmpty(tmp)) {
        setPage(tmp)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName])

  return (
    <Box pt={10} pb={10} px={[6, 20, 20, 24, 40]}>
      {!_.isEmpty(html) && <HtmlContainer html={html} />}
    </Box>
  )
}
export default StaticPage
